
import React, { useState } from "react";
import Select from "react-select";
import { Card, ListGroup } from "react-bootstrap"
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

//Images
import defaultAvatar from "../../../../src/assets/images/avatar/patient_profile.png";
import image from "../../../../src/assets/images/thumbnail.png";
import image1 from "../../../../src/assets/images/Student-Medical-Report.jpg";
import image2 from "../../../../src/assets/images/University-HEalth-Report.jpg";
import image3 from "../../../../src/assets/images/patient.jpg";
// Appoinments

const occupationOptions = [
  { value: "Doctor", label: "Doctor" },
  { value: "Nurse", label: "Nurse" },
  { value: "Engineer", label: "Engineer" },
  { value: "Teacher", label: "Teacher" },
  { value: "Farmer", label: "Farmer" },
  { value: "Housewife", label: "Housewife" },
  { value: "Student", label: "Student" },
  { value: "Businessman", label: "Businessman" },
  { value: "Driver", label: "Driver" },
  { value: "Electrician", label: "Electrician" },
  { value: "Plumber", label: "Plumber" },
  { value: "Carpenter", label: "Carpenter" },
  { value: "Lawyer", label: "Lawyer" },
  { value: "Police Officer", label: "Police Officer" },
  { value: "Artist", label: "Artist" },
  { value: "Actor", label: "Actor" },
  { value: "Scientist", label: "Scientist" },
  { value: "Retired", label: "Retired" },
  { value: "Unemployed", label: "Unemployed" },
  { value: "Other", label: "Other" },
];

const initialEvents = [
  {
    title: "Vaman<br>Treatment 1",
    start: new Date("2025-03-01 00:00"),
    end: new Date("2025-03-01 01:00"),
    id: "vaman",
    classNames: ["bg-primary"],
    completed: true,
  },
  {
    title: "Vaman<br>Treatment 2",
    start: new Date("2025-03-02 00:00"),
    end: new Date("2025-03-02 01:00"),
    id: "vaman-2",
    classNames: ["bg-primary"],
    completed: true,
  },
  {
    title: "Vaman<br>Treatment 3",
    start: new Date("2025-03-03 00:00"),
    end: new Date("2025-03-03 01:00"),
    id: "vaman-3",
    classNames: ["bg-primary"],
    completed: true,
  },
  {
    title: "Vaman<br>Treatment 4",
    start: new Date("2025-03-04 00:00"),
    end: new Date("2025-03-04 01:00"),
    id: "vaman-4",
    classNames: ["bg-primary"],
    completed: true,
  },
  {
    title: "Vaman<br>Treatment 5",
    start: new Date("2025-03-05 00:00"),
    end: new Date("2025-03-05 01:00"),
    id: "vaman-5",
    classNames: ["bg-primary"],
    completed: true,
  },
  {
    title: "Vaman<br>Treatment 6",
    start: new Date("2025-03-06 00:00"),
    end: new Date("2025-03-06 01:00"),
    id: "vaman-6",
    classNames: ["bg-primary"],
    completed: true,
  },
  {
    title: "Virechan<br>Treatment 1",
    start: new Date("2025-03-07 00:00"),
    end: new Date("2025-03-07 01:00"),
    id: "virechan-1",
    classNames: ["bg-secondary"],
    completed: false,
  },
  {
    title: "Virechan<br>Treatment 2",
    start: new Date("2025-03-08 00:00"),
    end: new Date("2025-03-08 01:00"),
    id: "virechan-2",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Virechan<br>Treatment 3",
    start: new Date("2025-03-09 00:00"),
    end: new Date("2025-03-09 01:00"),
    id: "virechan-3",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Virechan<br>Treatment 4",
    start: new Date("2025-03-10 00:00"),
    end: new Date("2025-03-10 01:00"),
    id: "virechan-4",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Virechan<br>Treatment 5",
    start: new Date("2025-03-11 00:00"),
    end: new Date("2025-03-11 01:00"),
    id: "virechan-5",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Basti<br>Treatment 1",
    start: new Date("2025-03-12 00:00"),
    end: new Date("2025-03-12 01:00"),
    id: "basti-1",
    classNames: ["bg-red"],
    completed: false,
  },
  {
    title: "Basti<br>Treatment 2",
    start: new Date("2025-03-13 00:00"),
    end: new Date("2025-03-13 01:00"),
    id: "basti-2",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Basti<br>Treatment 3",
    start: new Date("2025-03-14 00:00"),
    end: new Date("2025-03-14 01:00"),
    id: "basti-3",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Basti<br>Treatment 4",
    start: new Date("2025-03-15 00:00"),
    end: new Date("2025-03-15 01:00"),
    id: "basti-4",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Basti<br>Treatment 5",
    start: new Date("2025-03-16 00:00"),
    end: new Date("2025-03-16 01:00"),
    id: "basti-5",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Nasya<br>Treatment 1",
    start: new Date("2025-03-17 00:00"),
    end: new Date("2025-03-17 01:00"),
    id: "nasya-1",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Nasya<br>Treatment 2",
    start: new Date("2025-03-18 00:00"),
    end: new Date("2025-03-18 01:00"),
    id: "nasya-2",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Nasya<br>Treatment 3",
    start: new Date("2025-03-19 00:00"),
    end: new Date("2025-03-19 01:00"),
    id: "nasya-3",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Nasya<br>Treatment 4",
    start: new Date("2025-03-20 00:00"),
    end: new Date("2025-03-20 01:00"),
    id: "nasya-4",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Nasya<br>Treatment 5",
    start: new Date("2025-03-21 00:00"),
    end: new Date("2025-03-21 01:00"),
    id: "nasya-5",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Raktamokshan<br>Treatment 1",
    start: new Date("2025-03-22 00:00"),
    end: new Date("2025-03-22 01:00"),
    id: "raktamokshan-1",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Raktamokshan<br>Treatment 2",
    start: new Date("2025-03-23 00:00"),
    end: new Date("2025-03-23 01:00"),
    id: "raktamokshan-2",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Raktamokshan<br>Treatment 3",
    start: new Date("2025-03-24 00:00"),
    end: new Date("2025-03-24 01:00"),
    id: "raktamokshan-3",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Raktamokshan<br>Treatment 4",
    start: new Date("2025-03-25 00:00"),
    end: new Date("2025-03-25 01:00"),
    id: "raktamokshan-4",
    classNames: ["bg-warning"],
    completed: false,
  },
  {
    title: "Raktamokshan<br>Treatment 5",
    start: new Date("2025-03-26 00:00"),
    end: new Date("2025-03-26 01:00"),
    id: "raktamokshan-5",
    classNames: ["bg-warning"],
    completed: false,
  },
];
const Patientprofile = () => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isPersonalModalOpen, setIsPersonalModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isPlatformModalOpen, setIsPlatformModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isFileInputDisabled, setIsFileInputDisabled] = useState(false);
  const [question, setQuestion] = useState("");
  const [questionType, setQuestionType] = useState("short_answer");
  const [details, setDetails] = useState("");
  const [paragraph, setParagraph] = useState("");
  const [isRequired, setIsRequired] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [noteDescription, setNoteDescription] = useState("");
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [isFollowUpModalVisible, setIsFollowUpModalVisible] = useState(false);
  const [followUpReason, setFollowUpReason] = useState("");
  const [nextAction, setNextAction] = useState("");
  const [nextFollowUpDate, setNextFollowUpDate] = useState("");
  const [isDiseaseModalOpen, setIsDiseaseModalOpen] = useState(false);
  const [multipleChoiceOptions, setMultipleChoiceOptions] = useState([
    "Option 1",
    "Option 2",
  ]);
  const [checkboxOptions, setCheckboxOptions] = useState([
    "Option 1",
    "Option 2",
  ]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [showValidationOptions, setShowValidationOptions] = useState(false);
  const [validationType, setValidationType] = useState("");
  const [isFirstSwitchOn, setIsFirstSwitchOn] = useState(false);
  const [calendarEvents, setCalendarEvents] = useState(initialEvents);

  const [formData, setFormData] = useState({
    diseases: ["diabetes", "sleepProblem", "dentalCare", "hypertension"],
    platforms: ["instagram", "facebook", "campaignName1", "campaignName2"],
    name: "Cive Slauw",
    Contact: "+1234567890",
    email: "info@example.com",
    profileImage: defaultAvatar,
    branch: "Nashik",
    additionalContact: "+1234567890",
    dob: "January 1, 1995",
    height: "175 cm",
    weight: "70 kg",
    address: "Nashik",
    occupation: "",
    married: false,
    marriageHistory: "1st Marriage (Age 30)",
    marriageDate: "2015-06-15",
    center: "Nashik",
    spouseOption: "withoutSpouse",
    spouseName: "John Doe",
    idProof: "Passport",
    idNumber: "AB1234567",

    //Address details
    tempAddressLine1: "Akshya Nagar 1st Block 1st Cross",
    tempAddressLine2: "",
    tempArea: "Rammurthy Nagar",
    tempCity: "Bangalore",
    tempState: "Karnataka",
    tempPincode: "560016",
    addressLine1: "Akshya Nagar 1st Block 1st Cross",
    addressLine2: "",
    area: "Rammurthy Nagar",
    city: "Bangalore",
    state: "Karnataka",
    pincode: "560016",
    country: "",

    //Question feilds
    surname: "",
    firstName: "",
    husbandOrFatherName: "",
    dob1: "",
    age: "",
    whatsappNumber1: "",
    weighting: "",
    city1: "",
    district: "",
    profession: "",
    stomachCleaned: "",
    stomachClearedFeeling: "",
    hungerLevel: "",
    breakfastTime: [],
    mealRegularity: "",
    occasionalEating: "",
    foodPreference: [],
    thirstLevel: "",
    waterHabit: "",
    sleepHabit: "",
  });
  //service caller

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const platformOptions = [
    { value: "instagram", label: "Instagram" },
    { value: "facebook", label: "Facebook" },
    { value: "campaignName1", label: "Campaign Name 1" },
    { value: "campaignName2", label: "Campaign Name 2" },
  ];

  const handleMultiSelectChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prevState) => ({
      ...prevState,
      platforms: selectedValues, // Updated from diseases to platforms
    }));
  };
  const handleSubmitProfile = (e) => {
    e.preventDefault();
    console.log("Updated Profile Data:", formData);
    setIsProfileModalOpen(false); // Close the modal after submission
  };
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      setImagePreview(URL.createObjectURL(file)); // Create a preview URL for the image
    } else {
      setSelectedImage(null);
      setImagePreview(null);
    }
  };

  const handleSubmitPersonal = (e) => {
    e.preventDefault();
    console.log("Personal Data:", formData);
    setIsPersonalModalOpen(false); // Close the modal after submission
  };

  const handleSubmitAddress = (e) => {
    e.preventDefault();
    console.log("Address Data:", formData);
    setIsAddressModalOpen(false); // Close the modal after submission
  };

  const handleSubmitPlatforms = (e) => {
    e.preventDefault();
    console.log("Platforms Data:", formData.platforms); // Updated to platforms
    setIsPlatformModalOpen(false); // Close the modal after submission
  };
  // question forms

  const [sentiments, setSentiments] = useState(
    multipleChoiceOptions.map(() => "neutral") // Initialize all to 'neutral'
  );
  const handleQuestionChange = (e) => {
    setQuestion(e.target.value);
    validateForm(e.target.value);
  };

  const handleDetailsChange = (e) => {
    setDetails(e.target.value);
    validateForm(e.target.value);
  };

  const handleParagraphChange = (e) => {
    setParagraph(e.target.value);
  };

  const handleTypeChange = (e) => {
    setQuestionType(e.target.value);
    validateForm(question);
    setShowValidationOptions(false);
    setValidationType("");
  };

  const validateForm = (value) => {
    if (value.trim() === "") {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      `Question Submitted: ${question}\nDetails: ${details}\nParagraph: ${paragraph}\nMultiple Choice Options: ${multipleChoiceOptions.join(
        ", "
      )}\nCheckbox Options: ${checkboxOptions.join(
        ", "
      )}\nDate: ${selectedDate}\nTime: ${selectedTime}`
    );
  };

  const handleToggleChange = () => {
    setIsToggleOn(!isToggleOn);
  };

  const handleOptionChange = (index, value, type) => {
    if (type === "multiple_choice") {
      const updatedOptions = [...multipleChoiceOptions];
      updatedOptions[index] = value;
      setMultipleChoiceOptions(updatedOptions);
    } else {
      const updatedOptions = [...checkboxOptions];
      updatedOptions[index] = value;
      setCheckboxOptions(updatedOptions);
    }
  };
  const addhandleopn = () => {
    setCheckboxOptions([...checkboxOptions, ""]);
  };
  const handleMultipleChoiceChange = (index, value) => {
    const updatedOptions = [...multipleChoiceOptions];
    updatedOptions[index] = value;
    setMultipleChoiceOptions(updatedOptions);
  };

  const addMultipleChoiceOption = () => {
    setMultipleChoiceOptions([...multipleChoiceOptions, ""]);
  };

  const deleteMultipleChoiceOption = () => {
    if (multipleChoiceOptions.length > 0) {
      const updatedOptions = multipleChoiceOptions.slice(0, -1); // Remove the last option
      setMultipleChoiceOptions(updatedOptions);
    }
  };
  const deleteChoiceOption = () => {
    if (multipleChoiceOptions.length > 0) {
      const updatedOptions = multipleChoiceOptions.slice(0, -1); // Remove the last option
      setMultipleChoiceOptions(updatedOptions);
    }
  };
  const handleFirstSwitchChange = () => {
    setIsFirstSwitchOn((prevState) => {
      const newState = !prevState; // Toggle the state
      console.log(
        newState ? "Switching to Important" : "Switching to Not Important"
      );
      return newState; // Return the new state
    });
  };

  const handleSentimentChange = (index, value) => {
    const updatedSentiments = [...sentiments];
    updatedSentiments[index] = value; // Update the sentiment for the specific option
    setSentiments(updatedSentiments);
  };

  // Notes
  const handleAddNote = () => {
    // Handle the note submission logic here
    console.log("Note Added:", noteDescription);
    setNoteDescription(""); // Clear the text area
    handleClose(); // Close the modal
  };
  // folllow up
  const openFollowUpModal = () => setIsFollowUpModalVisible(true);
  const closeFollowUpModal = () => {
    setIsFollowUpModalVisible(false);
    // Reset form fields when closing the modal
    setFollowUpReason("");
    setNextAction("");
    setNextFollowUpDate("");
  };
  const handleAddFollowUp = () => {
    // Logic to add the follow-up
    console.log(followUpReason, nextAction, nextFollowUpDate);
    closeFollowUpModal(); // Close the modal after adding the follow-up
  };
  // question fileds
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (name) => (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFormData((prevState) => ({
        ...prevState,
        [name]: [...prevState[name], value],
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: prevState[name].filter((item) => item !== value),
      }));
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Form Data:', formData);
  // };

  const eventClick = (eventClick) => {
    const event = eventClick.event;
    if (event.extendedProps.completed) {
      Swal.fire({
        title: event.title,
        text: "This Treatment is completed.",
        icon: "info",
      });
      return;
    }

    Swal.fire({
      title: event.title,
      html: generateTreatmentCheckboxes(),
      showCancelButton: true,
      confirmButtonText: "Remove",
      confirmButtonColor: "#d33",
      cancelButtonText: "Close",
      preConfirm: () => {
        event.remove();
        Swal.fire("Deleted!", "Your Event has been deleted.", "success");
      },
    });
  };

  const generateTreatmentCheckboxes = () => {
    return `
      <div style="text-align: left;">
        ${[1, 2, 3]
        .map(
          (i) => `
          <div class="form-check mb-1" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="form-check-label" for="treatment${i}">Treatment ${i}</label>
            <input type="checkbox" class="form-check-input" id="treatment${i}" />
          </div>
        `
        )
        .join("")}
      </div>
    `;
  };

  const handleEventDrop = (info) => {
    const { event } = info;
    const newStart = info.event.start;
    const oldStart = info.oldEvent.start;

    if (newStart < oldStart) {
      Swal.fire({
        title: "Invalid Action",
        text: "You cannot move events to previous dates.",
        icon: "error",
      });
      info.revert();
      return;
    }

    if (event.extendedProps.completed) {
      Swal.fire({
        title: "Invalid Action",
        text: "You cannot move completed events.",
        icon: "error",
      });
      info.revert();
      return;
    }

    const daysDiff = Math.floor((newStart - oldStart) / (1000 * 60 * 60 * 24));
    const updatedEvents = calendarEvents.map((e) => {
      if (new Date(e.start) >= oldStart) {
        const newEventStart = new Date(e.start);
        newEventStart.setDate(newEventStart.getDate() + daysDiff);
        const newEventEnd = new Date(e.end);
        newEventEnd.setDate(newEventEnd.getDate() + daysDiff);
        return { ...e, start: newEventStart, end: newEventEnd };
      }
      return e;
    });

    setCalendarEvents(updatedEvents);
    Swal.fire({
      title: "Events Rescheduled",
      text: `The selected event have been moved by ${daysDiff} day(s).`,
      icon: "info",
    });
  };

  const handleEventDragStart = (info) => {
    if (info.event.extendedProps.completed) {
      info.jsEvent.preventDefault();
    }
  };

  const renderEventContent = (eventInfo) => {
    return (
      <div
        className={eventInfo.event.classNames.join(" ")}
        style={{
          color: "white",
          padding: "10px",
          borderRadius: "5px",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          textAlign: "center",
          fontSize: "1.2em",
        }}
        dangerouslySetInnerHTML={{ __html: eventInfo.event.title }}
      />
    );
  };
  const diseaseOptions = [
    { value: "diabetes", label: "Diabetes" },
    { value: "sleepProblem", label: "Sleep Problem" },
    { value: "dentalCare", label: "Dental Care" },
    { value: "hypertension", label: "Hypertension" },
  ];

  const handleSubmitDiseases = (e) => {
    e.preventDefault();
    console.log("Diseases Data:", formData.diseases);
    setIsDiseaseModalOpen(false); // Close the modal after submission
  };
  const handleEditDiseaseClick = () => {
    setIsDiseaseModalOpen(true);
  };
  const handleMultiSelectOnChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData((prevState) => ({
      ...prevState,
      diseases: selectedValues,
    }));
  };
  const [modifiedPrescriptions, setModifiedPrescriptions] = useState([
    {
      medicineName: "Eladi Gaan kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "3", // Updated quantity
      deliveredQuantity: "2", // Added delivered quantity
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    {
      medicineName: "Asthi - majja pachak kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "3", // Updated quantity
      deliveredQuantity: "2", // Added delivered quantity
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    {
      medicineName: "Amrutadi visarp kadha",
      dose: "1",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake:
        "Boil half a teaspoon of the medicine + 2 cups of water together, save half a cup of water, then strain and drink.",
    },
    {
      medicineName: "Amrutadi kushtha kadha",
      dose: "1",
      frequency: "Morning (5am to 9am)",
      quantity: "3",
      deliveredQuantity: "2",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Amrutadi Vatrakt kadha",
      dose: "2",
      frequency: "Morning (5am to 9am)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Ajirnakantak ras",
      dose: "2",
      frequency: "Morning (5am to 9am)",
      quantity: "4",
      deliveredQuantity: "2",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Aampachak vati",
      dose: "2",
      frequency: "Morning (5am to 9am)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Arogyavardhini",
      dose: "2",
      frequency: "BD - Morning (5am to 9am) - Evening (4pm to 7pm)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Avipttikar",
      dose: "1",
      frequency: "At night (around 10 pm)",
      quantity: "3",
      deliveredQuantity: "2",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Amalaki + haritaki vati",
      dose: "2",
      frequency: "At night (around 10 pm)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With plain/lukewarm water",
    },
    {
      medicineName: "Aavecha yog vati",
      dose: "2",
      frequency: "At night (around 10 pm)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With pomegranate juice",
    },
    {
      medicineName: "Amruta guggul",
      dose: "2",
      frequency: "At night (around 10 pm)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With pomegranate juice",
    },
    {
      medicineName: "Asanadi yog no.1",
      dose: "1",
      frequency: "Morning (5am to 9am)",
      quantity: "1",
      deliveredQuantity: "1",
      howToTake: "With pomegranate juice",
    },
  ]);
  
  return (
    <>
      <div className="row">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
          <Link to="/doctor" className="btn btn-link">
            <Button variant="primary">Back</Button>
          </Link>
        </div>
        <div className="col-lg-4">
          <div className="card">
            <div className="card-body">
              <div className="media d-sm-flex d-block text-center text-sm-start pb-4 mb-4 border-bottom">
                <img
                  alt=""
                  className="rounded me-sm-4 me-0"
                  width={100}
                  // src={avater}
                  src={formData.profileImage}
                />
                <div className="media-body align-items-center">
                  <div className="d-sm-flex d-block justify-content-between my-3 my-sm-0">
                    <div>
                      <h3 className="fs-22 text-black font-w600 mb-3">
                        {formData.name}
                      </h3>
                    </div>
                    {/* <span className="me-3">
                      <Link
                        to="#"
                        onClick={() => setIsPersonalInfoModalOpen(true)} // Open the personal info modal
                        className="edit-staff"
                      >
                        <i className="fa fa-pencil fs-18 text-success"></i>
                      </Link>
                    </span> */}
                  </div>

                  {/* Container for the buttons to align them side by side */}
                  <div className="d-flex align-items-center">
                    <Link
                      to="#"
                      className="btn bgl-primary btn-rounded text-black mb-2 me-2"
                    >
                      <svg
                        className="me-2 scale5"
                        width={10}
                        height={10}
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18 0.500061V3.00006H21.25L16.625 7.62506C15 6.25006 12.875 5.50006 10.5 5.50006C5 5.50006 0.5 10.0001 0.5 15.5001C0.5 21.0001 5 25.5001 10.5 25.5001C16 25.5001 20.5 21.0001 20.5 15.5001C20.5 13.1251 19.75 11.0001 18.375 9.37506L23 4.75006V8.00006H25.5V0.500061H18ZM10.5 23.0001C6.375 23.0001 3 19.6251 3 15.5001C3 11.3751 6.375 8.00006 10.5 8.00006C14.625 8.00006 18 11.3751 18 15.5001C18 19.6251 14.625 23.0001 10.5 23.0001Z"
                          fill="#2BC155"
                        />
                      </svg>
                      Male
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <h5 className="f-w-500"> Contact Number:</h5>
                  <span>{formData.additionalContact}</span>
                </div>
                <div className="col-6">
                  <h5 className="f-w-500">Date of Birth:</h5>
                  <span>{formData.dob}</span>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <h5 className="f-w-500">Height (cm):</h5>
                  <span>{formData.height}</span>
                </div>
                <div className="col-6">
                  <h5 className="f-w-500">Weight (kg):</h5>
                  <span>{formData.weight}</span>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <h5 className="f-w-500">Marriage History:</h5>
                  <span>{formData.marriageHistory}</span>{" "}
                  {/* e.g., "1st / 2nd / 3rd with Age" */}
                </div>
                <div className="col-6">
                  <h5 className="f-w-500">Marriage Date:</h5>
                  <span>{formData.marriageDate}</span>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <h5 className="f-w-500">Occupation:</h5>
                  <span>{formData.occupation}</span>
                </div>
                <div className="col-6">
                  <h5 className="f-w-500">Husband/Spouse Name:</h5>
                  <span>{formData.spouseName}</span>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-6">
                  <h5 className="f-w-500">Branch:</h5>
                  <span>{formData.center}</span>
                </div>
                <div className="col-6">
                  <h5 className="f-w-500">Spouse Option :</h5>
                  <span>{formData.spouseOption}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`modal fade ${isPersonalModalOpen ? "show" : ""}`}
            style={{
              display: isPersonalModalOpen ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="editPersonalModalLabel"
            aria-hidden={!isPersonalModalOpen}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="editPersonalModalLabel">
                    Edit Personal Information
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-sm"
                    onClick={() => setIsPersonalModalOpen(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmitPersonal}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label> Contact Number</label>
                          <input
                            type="text"
                            className="form-control"
                            name="additionalContact"
                            maxLength="10"
                            value={formData.additionalContact}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Date of Birth</label>
                          <input
                            type="text"
                            className="form-control"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            required
                          />
                          <i
                            className="fa fa-calendar position-absolute"
                            style={{
                              right: "15px",
                              top: "65%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              fontSize: "18px",
                            }}
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Height (cm)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="height"
                            value={formData.height}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Weight (kg)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="weight"
                            value={formData.weight}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Occupation</label>
                          <Select
                            name="occupation"
                            options={Options}
                            value={
                              formData.occupation
                                ? occupationOptions.find(
                                  (option) => option.value === formData.occupation
                                )
                                : null
                            }
                            onChange={(selectedOption) =>
                              setFormData((prev) => ({
                                ...prev,
                                occupation: selectedOption ? selectedOption.value : "",
                              }))
                            }
                            
                            placeholder="Select Occupation"
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minHeight: "50px",
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: "#e3f2fd",
                                color: "#1976d2",
                              }),
                              multiValueLabel: (provided) => ({
                                ...provided,
                                color: "#1976d2",
                                fontWeight: "500",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "4px",
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none",
                              }),
                            }}
                          />
                        </div>

                      </div>
                      <div className="col-6">
                        <h5 className="f-w-500">Married</h5>
                        <div className="form-check form-check-inline">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="married"
                            checked={formData.married}
                            onChange={handleChange}
                            id="marriedCheckbox" // Add an ID for accessibility
                          />
                          <label
                            className="form-check-label"
                            htmlFor="marriedCheckbox"
                          >
                            Married
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label>Date of Marriage</label>
                          <input
                            type="text"
                            className="form-control"
                            name="marriageDate"
                            value={formData.marriageDate}
                            onChange={handleChange}
                            required
                          />
                          <i
                            className="fa fa-calendar position-absolute"
                            style={{
                              right: "15px",
                              top: "65%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              fontSize: "18px",
                            }}
                          ></i>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Husband/Spouse Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="spouseName"
                            value={formData.spouseName}
                            onChange={handleChange}
                            required
                          />
                        </div>{" "}
                        height: "370px",
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group position-relative">
                          <label className="form-label">ID Proof</label>
                          <div style={{ position: "relative" }}>
                            <select
                              className="form-control"
                              name="idProof"
                              value={formData.idProof}
                              onChange={handleChange}
                              required
                              style={{
                                paddingRight: "30px",
                                appearance: "none",
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                              }}
                            >
                              <option value="PAN">PAN</option>
                              <option value="Aadhar">Aadhar</option>
                              <option value="Driving License">
                                Driving License
                              </option>
                            </select>
                            <i
                              className="fa fa-caret-down"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                              }}
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>ID Number</label>
                          <input
                            type="text"
                            className="form-control"
                            name="idNumber"
                            value={formData.idNumber}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="btn btn-primary mt-3">
                      Update
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card" style={{ width: "100%" }}>
            <div className="card-header border-0 pb-0">
              <h4 className="fs-18 text-black font-w600 mb-0">Notes</h4> {/* Title changed to "Notes" */}
            </div>
            <div className="card-body pt-4">
              <div id="DZ_W_Todo2" className="widget-media dz-scroll height400">
                <div className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                  <h6 className="font-weight-bold">
                    Patient missed last appointment, rescheduling requested.
                  </h6>
                  <p className="fs-15 mb-0">Date: Jan 10, 2025</p>
                  <p className="fs-15 mb-0">Notes By: Dr. John Doe</p>
                </div>
                <div className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                  <h6 className="font-weight-bold">
                    Patient confirmed visit for general check-up.
                  </h6>
                  <p className="fs-15 mb-0">Date: Jan 10, 2025</p>
                  <p className="fs-15 mb-0">Notes By: Dr. John Doe</p>
                </div>
                <div className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                  <h6 className="font-weight-bold">
                    Multiple calls, no response. Try again later.
                  </h6>
                  <p className="fs-15 mb-0">Date: Jan 10, 2025</p>
                  <p className="fs-15 mb-0">Notes By: Dr. John Doe</p>
                </div>
                <div className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                  <h6 className="font-weight-bold">
                    Patient postponed due to personal reasons.
                  </h6>
                  <p className="fs-15 mb-0">Date: Jan 10, 2025</p>
                  <p className="fs-15 mb-0">Notes By: Dr. John Doe</p>
                </div>
                <div className="mb-2 custom-timeline-panel timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                  <h6 className="font-weight-bold">
                    Interested in a health package, requested more details.
                  </h6>
                  <p className="fs-15 mb-0">Date: Jan 10, 2025</p>
                  <p className="fs-15 mb-0">Notes By: Dr. John Doe</p>
                </div>


              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card" style={{ width: "100%" }}>
            <div className="card-header border-0 pb-0">
              <h4 className="fs-18 text-black font-w600 mb-0">
                Important Questions
              </h4>
            </div>
            <div className="card-body pt-4">
              <div id="DZ_W_Todo2" className="widget-media dz-scroll height400">
                <ul className="timeline">
                  <li>
                    <div className="timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                      <div className="media-body">
                        <h5 className="mb-1 fs-18">
                          How are you going to do consulting?
                        </h5>
                        <span>Nashik Center</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                      <div className="media-body">
                        <h5 className="mb-1 fs-18">How do you feel hungry?</h5>
                        <span>More</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                      <div className="media-body">
                        <h5 className="mb-1 fs-18">
                          When do you have breakfast?
                        </h5>
                        <span>Afternoon</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                      <div className="media-body">
                        <h5 className="mb-1 fs-18">When do you eat?</h5>
                        <span>Morning</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="timeline-panel bgl-dark flex-wrap border-0 p-3 rounded">
                      <div className="media-body">
                        <h5 className="mb-1 fs-18">
                          Are meal and snack times regular?
                        </h5>
                        <span>No</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal ${isProfileModalOpen ? "show" : ""}`}
          style={{
            display: isProfileModalOpen ? "block" : "none",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setIsProfileModalOpen(false)}
                ></button>
              </div>
              <form onSubmit={handleSubmitProfile}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="col-form-label">Profile Image:</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleImageChange}
                      disabled={isFileInputDisabled}
                    />
                    {selectedImage && (
                      <small className="form-text text-muted">
                        Selected file: {selectedImage.name}
                      </small>
                    )}
                    {imagePreview && (
                      <div className="mt-2">
                        <img
                          src={imagePreview}
                          alt="Profile Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mb-3 " style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      name="branch"
                      value={formData.branch}
                      onChange={handleChange}
                      required
                      style={{
                        paddingRight: "30px",
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                      }}
                    >
                      <option value="">Select Branch</option>
                      <option value="Nashik">Nashik</option>
                      <option value="Pune">Pune</option>
                      <option value="Mumbai">Mumbai</option>
                    </select>
                    <i
                      className="fa fa-caret-down"
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                      }}
                    ></i>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">
                      WhatsApp Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phone"
                      name="additionalContact"
                      value={formData.Contact}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary mt-3">
                    {" "}
                    Update{" "}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="fs-22 text-black font-w600 mb-0">Platform</h4>
              </div>
              <div className="d-flex flex-row justify-content-start align-items-center mb-3">
                <div className="media me-3">
                  <div className="media-body">
                    <h5 className="mt-0 vertical-text bg-primary rounded-pill px-3 py-2 text-white">
                      Instagram
                    </h5>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <h5 className="fs-18 font-w600">Upcoming Follow Ups :</h5>
                <div className="subheading">
                  <p className="mb-1"> Rescheduling confirmation</p>
                  <p className="mb-1">Next action - Call again on 10-Feb</p>
                  <p className="mb-1">Next Follow-Up: 10-Feb-2025</p>
                </div>
              </div>

              <div>
                <h5 className="fs-18 font-w600">Latest Notes:</h5>
                <div className="subheading">
                  <p className="mb-1">
                    Rescheduling confirmation Next action - Call again on 10-Feb
                  </p>
                  <p className="fs-15 mb-0">Date: 11 Jan 2025, 11 AM - 12 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Diseases Modal */}
          <div
            className={`modal fade ${isPlatformModalOpen ? "show" : ""}`}
            style={{
              display: isPlatformModalOpen ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="editPlatformModalLabel"
            aria-hidden={!isPlatformModalOpen}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="editPlatformModalLabel">
                    Edit Platform Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-sm"
                    onClick={() => setIsPlatformModalOpen(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmitPlatforms}>
                    <Select
                      isMulti
                      name="platforms"
                      options={platformOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={handleMultiSelectChange}
                      value={platformOptions.filter((option) =>
                        formData.platforms.includes(option.value)
                      )}
                      styles={{ marginBottom: "20px" }} // Add margin for spacing
                    />
                    <button type="submit" className="btn btn-primary mt-3">
                      Update
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="fs-22 text-black font-w600 mb-0">Diseases</h4>
              </div>
              <div className="d-flex flex-row justify-content-start align-items-center mb-4">
                {diseaseOptions.map((option) => (
                  <div className="media me-4" key={option.value}>
                    <div className="media-body">
                      <h5 className="mt-0 vertical-text bg-primary rounded-pill px-3 py-2 text-white">
                        {option.label}
                      </h5>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mb-4">
                <h5 className="fs-18 font-w600">Upcoming Visits:</h5>
                <div className="subheading">
                  <p className="mb-1">Routine Checkup</p>
                  <p className="fs-15 mb-0">
                    Date: Jan 10, 2025, 10 AM - 11 AM
                  </p>
                  <p className="mb-1">Doctor: Dr. John Doe</p>
                </div>
              </div>

              <div>
                <h5 className="fs-18 font-w600">Last Visits:</h5>
                <div className="subheading">
                  <p className="mb-1">Follow Up</p>
                  <p className="fs-15 mb-0">Date: 11 Jan 2025, 11 AM - 12 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Diseases Modal */}
          <div
            className={`modal fade ${isDiseaseModalOpen ? "show" : ""}`}
            style={{
              display: isDiseaseModalOpen ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="editDiseaseModalLabel"
            aria-hidden={!isDiseaseModalOpen}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="editDiseaseModalLabel">
                    Edit Disease Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-sm"
                    onClick={() => setIsDiseaseModalOpen(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmitDiseases}>
                    <Select
                      isMulti
                      name="diseases"
                      options={diseaseOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={handleMultiSelectOnChange}
                      value={diseaseOptions.filter((option) =>
                        formData.diseases.includes(option.value)
                      )}
                    />
                    <div style={{ marginBottom: "20px" }}></div>
                    <button type="submit" className="btn btn-primary mt-3">
                      Update
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-12">
          \
          <div className="card shadow-none">
            <div
              id="DZ_W_TimeLine"
              className="widget-timeline dz-scroll"

            >
              <ul className="timeline list-unstyled">
                {/* Ongoing Appointment */}
                <li className="mb-4">
                  <div className="timeline-badge bg-success rounded-circle"></div>
                  <div className="timeline-panel text-muted">
                    <span className="d-block mb-2" style={{ fontSize: "16px" }}>
                      Date: <strong>01/04/2025</strong>
                    </span>
                    {/*/Doctor Notes */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Doctor Note</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">

                        <p className="mb-0 text-dark">
                          Based on our initial consultation, your symptoms appear to be mild and manageable with some lifestyle adjustments and routine follow-up. I’ve recommended a few basic tests to better understand your condition, and we’ll review the results during your next visit.
                        </p>
                      </div>
                    </div>
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Telecaller Note</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">

                        <p className="mb-0 text-dark">   Komal appointment with Dr. Simth John on 10/04/2025 at 4pm.
                        </p>
                      </div>
                    </div>
                    {/*prescription */}
                    <div className="row mb-3">
                      <h5 className="fw-bold mb-3">Prescription</h5>
                      <div
                        style={{
                          // Set the height for the table container
                          // Enable scrolling if content overflows
                          border: "2px solid #ddd", // Outer border for the table
                          borderRadius: "5px", // Optional: to add rounded corners to the border
                        }}
                      >
                        <table
                          className="table header-border"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse", // Prevents double borders
                          }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f8f9fa",
                              zIndex: 10,
                              borderBottom: "2px solid #ddd", // Border below header
                            }}
                          >
                            <tr className="table-info">
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Medicine Name
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Dose
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Frequency
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Quantity
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                How to Take?
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              ></th>
                            </tr>
                          </thead>
                          <tbody>
                            {modifiedPrescriptions.map(
                              (prescription, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.medicineName}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.dose}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.frequency}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.quantity}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.howToTake}
                                  </td>

                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/*panchkarma */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Panchakarma Recommended</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">
                        <p className="fw-semibold text-dark mb-1">Panchakarma Name: Virechana</p>
                        <p className="mb-1 text-dark">Start Date: 15/04/2025</p>
                        <p className="mb-0 text-dark">No. of Days: 7</p>
                      </div>
                    </div>
                  </div>
                </li>

                {/* Scheduled Appointment */}
                <li className="mb-4">
                  <div className="timeline-badge bg-warning rounded-circle"></div>
                  <div className="timeline-panel text-muted">
                    <span className="d-block mb-2" style={{ fontSize: "16px" }}>
                      Date: <strong>03/04/2025</strong>
                    </span>
                    {/* counsellor Section */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Counsellor</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">
                        <p className="fw-semibold text-dark mb-1">Counsulting Date: 03/04/2025</p>
                        <p className="mb-1 text-dark">Medicine Explained Date: 03/04/2025</p>
                        <p className="mb-0 text-dark">Medicine Explained by: Sonali</p>
                      </div>
                    </div>
                    {/* medical Section */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Medical</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">
                        <p className="fw-semibold text-dark mb-1"> Medicine Prepared by : Rohit</p>
                        <p className="mb-1 text-dark">Medicine Sent Date: 03/04/2025</p>
                        <p className="mb-0 text-dark">Delivery Date :Courier</p>
                      </div>
                    </div>
                  </div>
                </li>
                {/* Notes Section */}
                <li className="mb-4">
                  <div className="timeline-badge bg-danger rounded-circle"></div>
                  <div className="timeline-panel text-muted">
                    <span className="d-block mb-2" style={{ fontSize: "16px" }}>
                      Date: <strong>05/04/2025</strong>
                    </span>
                    {/*Service caller*/}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Service Caller </h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">

                        <p className="mb-0 text-dark">  Followup Date : 05/04/2025
                        </p>
                      </div>
                    </div>
                    {/* Notes Section */}
                    <div className="mt-3">
                      <h5 className="fw-bold mb-3"> Notes</h5>
                      {[
                        "Patient missed last appointment, rescheduling requested.",
                        "Patient confirmed visit for general check-up.",
                        "Multiple calls, no response. Try again later.",
                        "Patient postponed due to personal reasons.",
                        "Interested in a health package, requested more details.",
                        "Prescribed By: Dr. John Doe",
                        "Prescribed By: Dr. John Doe"
                      ].map((note, index) => (
                        <div key={index} className="mb-3 p-3 rounded bg-white border shadow-sm">
                          <p className="fw-semibold text-dark mb-1">{note}</p>
                          <p className="mb-0 text-muted">Date: Jan 10, 2025</p>
                        </div>
                      ))}
                    </div>
                    {/* Questionnaire Section */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Questionnaire</h5>
                      {[
                        {
                          question: "How are you feeling since your last visit?",
                          answer: "I'm feeling much better.",
                        },
                        {
                          question: "Have you been taking the prescribed medications regularly?",
                          answer: "Yes, every day.",
                        },
                        {
                          question: "Are you experiencing any side effects or new symptoms?",
                          answer: "I feel drowsy.",
                        },
                        {
                          question: "Did you follow the diet and lifestyle advice given?",
                          answer: "Yes, mostly.",
                        },
                        {
                          question: "Have you done the recommended tests or investigations?",
                          answer: "Yes, I have the reports.",
                        },
                        {
                          question: "Do you feel there is improvement in your main symptoms?",
                          answer: "No improvement.",
                        },
                        {
                          question: "Do you have any difficulty in continuing the treatment or routine?",
                          answer: "I need help with it.",
                        },
                      ].map((qa, index) => (
                        <div key={index} className="mb-3 p-3 rounded bg-white border shadow-sm">
                          <p className="fw-semibold text-dark mb-1">
                            Q{index + 1}: {qa.question}
                          </p>
                          <p className="mb-0 text-dark">A: {qa.answer}</p>
                        </div>
                      ))}
                    </div>
                    {/*report*/}
                    <div className="col-xl-12">
                      <div className="card shadow-none">
                        <div className="card-body">
                          <div className="col-md-6">
                            <h4 className="fs-22 text-black font-w600 mb-0">Reports</h4>
                          </div>
                          <div className="row">
                            {/* First Row */}
                            <div className="col-md-6 d-flex justify-content-center mb-3">
                              <img
                                src={image}
                                alt="Descriptive Text"
                                className="img-fluid rounded"
                                style={{ width: "90%", height: "auto" }}
                              />
                            </div>
                            <div className="col-md-6 d-flex justify-content-center mb-3">
                              <img
                                src={image1}
                                alt="Descriptive Text"
                                className="img-fluid rounded"
                                style={{ width: "90%", height: "auto" }}
                              />
                            </div>

                            {/* Second Row */}
                            <div className="col-md-6 d-flex justify-content-center mb-3">
                              <img
                                src={image2}
                                alt="Descriptive Text"
                                className="img-fluid rounded"
                                style={{ width: "90%", height: "auto" }}
                              />
                            </div>
                            <div className="col-md-6 d-flex justify-content-center mb-3">
                              <img
                                src={image3}
                                alt="Descriptive Text"
                                className="img-fluid rounded"
                                style={{ width: "90%", height: "auto" }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                {/* Empty Timeline Marker */}
                <li>
                  <div className="timeline-badge bg-primary rounded-circle"></div>
                  <div className="timeline-panel text-muted">
                    <span className="d-block mb-2" style={{ fontSize: "16px" }}>
                      Date: <strong>07/04/2025</strong>
                    </span>
                    {/*Doctor Notes */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Doctor Note</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">

                        <p className="mb-0 text-dark">
                          Based on 07/04/2025 consultation, your symptoms currently seem to be mild and not concerning. With some simple lifestyle modifications and consistent follow-up, we should be able to manage them effectively.
                        </p>
                        <p className="mb-0 text-dark">
                          I’ve advised a few routine investigations to get a clearer picture of your overall health. We’ll go over the test results and discuss the next steps during your upcoming appointment.
                        </p>
                      </div>
                    </div>
                    {/*new prescription */}
                    <div className="row mb-3">
                      <h5 className="fw-bold mb-3">New Prescription</h5>
                      <div
                        style={{
                          // Set the height for the table container
                          // Enable scrolling if content overflows
                          border: "2px solid #ddd", // Outer border for the table
                          borderRadius: "5px", // Optional: to add rounded corners to the border
                        }}
                      >
                        <table
                          className="table header-border"
                          style={{
                            width: "100%",
                            borderCollapse: "collapse", // Prevents double borders
                          }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f8f9fa",
                              zIndex: 10,
                              borderBottom: "2px solid #ddd", // Border below header
                            }}
                          >
                            <tr className="table-info">
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Medicine Name
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Dose
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Frequency
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                Quantity
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                How to Take?
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              ></th>
                            </tr>
                          </thead>
                          <tbody>
                            {modifiedPrescriptions.map(
                              (prescription, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.medicineName}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.dose}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.frequency}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.quantity}
                                  </td>
                                  <td
                                    style={{
                                      padding: "10px",
                                    }}
                                  >
                                    {prescription.howToTake}
                                  </td>

                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* counsellor Section */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Counsellor</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">
                        <p className="fw-semibold text-dark mb-1">Counsulting Date: 07/04/2025</p>
                        <p className="mb-1 text-dark">Medicine Explained Date: 07/04/2025</p>
                        <p className="mb-0 text-dark">Medicine Explained by: Ajay</p>
                      </div>
                    </div>
                    {/* medical Section */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Medical</h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">
                        <p className="fw-semibold text-dark mb-1"> Medicine Prepared by : Rohit</p>
                        <p className="mb-1 text-dark">Medicine Sent Date: 07/04/2025</p>
                        <p className="mb-0 text-dark">Delivery Date :By hand</p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="timeline-badge bg-info rounded-circle"></div>
                  <div className="timeline-panel text-muted">
                    <span className="d-block mb-2" style={{ fontSize: "16px" }}>
                      Date: <strong>08/04/2025</strong>
                    </span>
                    {/*Service caller*/}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Service Caller </h5>
                      <div className="mb-3 p-3 rounded bg-white border shadow-sm">

                        <p className="mb-0 text-dark">  Followup Date - 08/04/2025
                        </p>
                      </div>
                    </div>
                    {/* Notes Section */}
                    <div className="mt-3">
                      <h5 className="fw-bold mb-3"> Notes</h5>
                      {[
                        "Contacted successfully, patient agreed to attend.",
                        "Visit purpose: Follow-up for ongoing symptoms and review of test reports.",
                      ].map((note, index) => (
                        <div key={index} className="mb-3 p-3 rounded bg-white border shadow-sm">
                          <p className="fw-semibold text-dark mb-1">{note}</p>
                          <p className="mb-0 text-muted">Date: April 10, 2025</p>
                        </div>
                      ))}
                    </div>
                    {/* Questionnaire Section */}
                    <div className="mt-4">
                      <h5 className="fw-bold mb-3">Questionnaire</h5>
                      {[
                        {
                          question: "How are you feeling since your last visit?",
                          answer: "Some symptoms have improved, but fatigue remains.",
                        },
                        {
                          question: "Have you been taking the prescribed medications regularly?",
                          answer: "Yes, I’ve been consistent.",
                        },
                        {
                          question: "Are you experiencing any side effects or new symptoms?",
                          answer: "Mild headaches occasionally.",
                        },
                        {
                          question: "Did you follow the diet and lifestyle advice given?",
                          answer: "Mostly, except for exercise due to work schedule.",
                        },
                        {
                          question: "Have you done the recommended tests or investigations?",
                          answer: "Yes, submitted all reports.",
                        },
                        {
                          question: "Do you feel there is improvement in your main symptoms?",
                          answer: "Slight improvement, but not fully resolved..",
                        },
                        {
                          question: "Do you have any difficulty in continuing the treatment or routine?",
                          answer: "Managing okay now with some support.",
                        },
                      ].map((qa, index) => (
                        <div key={index} className="mb-3 p-3 rounded bg-white border shadow-sm">
                          <p className="fw-semibold text-dark mb-1">
                            Q{index + 1}: {qa.question}
                          </p>
                          <p className="mb-0 text-dark">A: {qa.answer}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>


      </div>
    </>
  );
};

export default Patientprofile;
